// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import './FilterResults.sass';

// Interfaces
import FilterResult from "Interfaces/FilterResultInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";

// Components
import FilterResultsGroup from "./FilterResultsGroup";
import ResultFilterByHotel from "./ResultFilterByHotel";

type Props = {
  selectedFilters: SelectedFilters;
  filters: FilterResult;
  onClear: () => void;
  onSelect: (name: string, value: string) => void;
  toggleOpen: (name: string) => void;
  toggleFilter?: () => void;
  disableRoomTypeFilter?: boolean;
  disableViewFilter?: boolean;
  disableActivitiesFilter?: boolean;
  disableAreaFilter?: boolean;
  disableClearFilter?: boolean;
  id?: string
};

class FilterResults extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this)
    this.clear = this.clear.bind(this);
  }

  onSelect(name: string, value: string) {
    this.props.onSelect(name, value);
  
  }

  clear() {
    
    if (this.props.disableClearFilter) return;
    this.props.onClear();
  }
  toggleOpen(name: string) {
    this.props.toggleOpen(name);
  }
  toggleFilter() {
    let el: any = document.getElementById('html')
    let box: any = document.getElementById('filter-box');

    box.classList.toggle("display")
    el.classList.toggle("overflow")
  }



  render() {
  
    const { localize } = this.context;
    return (
      <React.Fragment>
        <aside className="columns two filter-wrapper" id="filter-box">
          <div className="filter-options-table">
            <div className="filter-options header">
              <button className="back-btn" onClick={this.toggleFilter}>← Back</button>
              {localize("static.content.narrow-results")}
            </div>
            <ul className="filter-body-wrapper">
              <li className="filter-type">
                <FilterResultsGroup
                  displayName={localize("static.content.room-type")}
                  onSelect={this.onSelect}
                  name="roomType"
                  disabled={this.props.disableRoomTypeFilter || this.props.filters["roomType"].length === 0}
                  items={this.props.filters["roomType"]}
                  selected={this.props.selectedFilters["roomType"].filters}
                  opened={this.props.selectedFilters["roomType"].expanded}
                  toggleOpen={this.toggleOpen} />
              </li>
              <li className="filter-type">
                <FilterResultsGroup
                  displayName={localize("static.content.view")}
                  onSelect={this.onSelect}
                  name="views"
                  disabled={this.props.disableViewFilter || this.props.filters["views"].length === 0}
                  items={this.props.filters["views"]}
                  selected={this.props.selectedFilters["views"].filters}
                  opened={this.props.selectedFilters["views"].expanded}
                  toggleOpen={this.toggleOpen} />
              </li>
              <li className="filter-type">
                <FilterResultsGroup
                  displayName={localize("static.content.activities")}
                  onSelect={this.onSelect}
                  name="activity"
                  disabled={this.props.disableActivitiesFilter || this.props.filters["activities"].length === 0}
                  items={this.props.filters["activities"]}
                  selected={this.props.selectedFilters["activity"].filters}
                  opened={this.props.selectedFilters["activity"].expanded}
                  toggleOpen={this.toggleOpen} />
              </li>
              <li className="filter-type by-hotel">
                <FilterResultsGroup
                  displayName={localize("static.content.area")}
                  name="area"
                  disabled={this.props.disableAreaFilter}
                  opened={this.props.selectedFilters["area"].expanded}
                  toggleOpen={this.toggleOpen}
                >
                  <ResultFilterByHotel
                    selectedCities={this.props.selectedFilters["area"].filters}
                    area={this.props.filters["area"]}
                    onSelect={this.onSelect} />
                </FilterResultsGroup>
              </li>
            </ul>
            <div className="clear-filters">
              <button onClick={this.clear}>{localize("static.content.clear-filters")}</button>
            </div>
          </div>
        </aside>
      </React.Fragment>
    );
  }
}

FilterResults.contextType = LocalizationContext;

export default FilterResults;
